module.exports = __webpack_public_path__ + "img/cooperativeMedia15.c1dd1559.png";